document.addEventListener('DOMContentLoaded', () => {
  const shop = document.querySelector('[data-field-shop]');
  if (!shop) return;
  const slides = [...shop.querySelectorAll('.field-slide')];
  const dots = [...shop.querySelectorAll('[data-field-dot]')];
  const products = [...shop.querySelectorAll('[data-field-products] .field-product')];
  let active = 0;
  let timer;
  const showSlide = (index) => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      const isActive = i === active;
      slide.classList.toggle('is-active', isActive);
      slide.querySelectorAll('video').forEach((video) => {
        if (isActive) video.play().catch(() => {});
        else video.pause();
      });
    });
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
  };
  const restart = () => {
    clearInterval(timer);
    timer = setInterval(() => showSlide(active + 1), 6500);
  };
  const applyFilter = (filter) => {
    shop.querySelectorAll('[data-field-filter]').forEach((button) => button.classList.toggle('is-active', button.dataset.fieldFilter === filter));
    products.forEach((product) => {
      product.hidden = filter !== 'all' && !product.dataset.search.includes(filter);
    });
  };
  shop.querySelector('[data-field-prev]')?.addEventListener('click', () => { showSlide(active - 1); restart(); });
  shop.querySelector('[data-field-next]')?.addEventListener('click', () => { showSlide(active + 1); restart(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { showSlide(i); restart(); }));
  shop.querySelectorAll('[data-field-filter]').forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.fieldFilter)));
  shop.querySelectorAll('[data-field-card-filter]').forEach((card) => {
    card.addEventListener('click', () => applyFilter(card.dataset.fieldCardFilter));
  });
  shop.querySelector('[data-field-sort]')?.addEventListener('change', (event) => {
    const grid = shop.querySelector('[data-field-products]');
    const value = event.target.value;
    const sorted = [...products].sort((a, b) => {
      if (value === 'name') return a.dataset.title.localeCompare(b.dataset.title);
      if (value === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
      if (value === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
      return 0;
    });
    sorted.forEach((product) => grid.append(product));
  });
  showSlide(0);
  restart();
});

document.addEventListener('DOMContentLoaded', () => {
  const shop = document.querySelector('[data-print-shop]');
  if (!shop) return;
  const products = [...shop.querySelectorAll('[data-print-products] .print-product')];
  const applyFilter = (filter) => {
    shop.querySelectorAll('[data-print-filter]').forEach((button) => button.classList.toggle('is-active', button.dataset.printFilter === filter));
    products.forEach((product) => { product.hidden = filter !== 'all' && !product.dataset.search.includes(filter); });
  };
  shop.querySelectorAll('[data-print-filter]').forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.printFilter)));
  shop.querySelector('[data-print-sort]')?.addEventListener('change', (event) => {
    const grid = shop.querySelector('[data-print-products]');
    const sorted = [...products].sort((a, b) => {
      if (event.target.value === 'name') return a.dataset.title.localeCompare(b.dataset.title);
      if (event.target.value === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
      if (event.target.value === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
      return 0;
    });
    sorted.forEach((product) => grid.append(product));
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('[data-product-gallery]');
  const lightbox = document.querySelector('[data-product-lightbox]');
  if (!gallery || !lightbox) return;
  const image = lightbox.querySelector('[data-zoom-image]');
  const resetButton = lightbox.querySelector('[data-zoom-reset]');
  const stage = lightbox.querySelector('[data-zoom-stage]');
  let scale = 1;
  let offsetX = 0;
  let offsetY = 0;
  let dragging = false;
  let pointerX = 0;
  let pointerY = 0;
  const updateScale = () => {
    image.style.transform = `translate3d(${offsetX}px,${offsetY}px,0) scale(${scale})`;
    resetButton.textContent = `${Math.round(scale * 100)}%`;
  };
  const setScale = (nextScale) => {
    scale = Math.min(3, Math.max(.5, nextScale));
    if (scale <= 1) {
      offsetX = 0;
      offsetY = 0;
    }
    updateScale();
  };
  const resetZoom = () => {
    scale = 1;
    offsetX = 0;
    offsetY = 0;
    updateScale();
  };
  gallery.querySelectorAll('[data-product-main-image]').forEach((mainTrigger) => {
    mainTrigger.addEventListener('click', () => {
      image.src = mainTrigger.dataset.productZoomSrc;
      image.alt = mainTrigger.dataset.productZoomAlt || '';
      resetZoom();
      lightbox.showModal();
      stage.focus();
    });
  });
  lightbox.querySelector('[data-zoom-in]').addEventListener('click', () => setScale(scale + .25));
  lightbox.querySelector('[data-zoom-out]').addEventListener('click', () => setScale(scale - .25));
  resetButton.addEventListener('click', resetZoom);
  lightbox.querySelector('[data-zoom-close]').addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });
  stage.addEventListener('wheel', (event) => {
    event.preventDefault();
    setScale(scale + (event.deltaY < 0 ? .15 : -.15));
  }, { passive: false });
  stage.addEventListener('pointerdown', (event) => {
    if (scale <= 1) return;
    dragging = true;
    pointerX = event.clientX;
    pointerY = event.clientY;
    stage.setPointerCapture(event.pointerId);
  });
  stage.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    offsetX += event.clientX - pointerX;
    offsetY += event.clientY - pointerY;
    pointerX = event.clientX;
    pointerY = event.clientY;
    updateScale();
  });
  const stopDragging = () => { dragging = false; };
  stage.addEventListener('pointerup', stopDragging);
  stage.addEventListener('pointercancel', stopDragging);
  stage.addEventListener('keydown', (event) => {
    if (event.key === '+' || event.key === '=') setScale(scale + .25);
    else if (event.key === '-') setScale(scale - .25);
    else if (event.key === '0') resetZoom();
    else if (event.key === 'Escape') lightbox.close();
    else if (event.key === 'ArrowLeft') offsetX -= 30;
    else if (event.key === 'ArrowRight') offsetX += 30;
    else if (event.key === 'ArrowUp') offsetY -= 30;
    else if (event.key === 'ArrowDown') offsetY += 30;
    else return;
    event.preventDefault();
    updateScale();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('.product-form');
    const info = select.closest('.product-info');
    const price = info?.querySelector('[data-product-price]');
    const comparePrice = info?.querySelector('[data-product-compare-price]');
    const availability = info?.querySelector('[data-product-availability]');
    const addButton = form?.querySelector('[data-add-to-cart]');
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
      }
      if (availability) availability.innerHTML = available ? '<strong>Available</strong> and ready to order' : '<strong>Sold out</strong>';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.dataset.availableLabel : 'Sold out';
      }
      if (option.dataset.mediaId) {
        document.querySelector(`[data-product-thumbnail][data-media-id="${option.dataset.mediaId}"]`)?.click();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.menu-toggle');
  const nav = document.querySelector('#PrimaryNav');
  if (!button || !nav) return;
  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
  });

  const shop = document.querySelector('[data-badminton-shop]');
  if (!shop) return;

  const slides = [...shop.querySelectorAll('.bd-slide')];
  const dots = [...shop.querySelectorAll('[data-bd-dot]')];
  let active = 0;
  let timer;
  const showSlide = (index) => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
  };
  const start = () => {
    clearInterval(timer);
    timer = setInterval(() => showSlide(active + 1), 6500);
  };
  shop.querySelector('[data-bd-prev]')?.addEventListener('click', () => { showSlide(active - 1); start(); });
  shop.querySelector('[data-bd-next]')?.addEventListener('click', () => { showSlide(active + 1); start(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { showSlide(i); start(); }));
  start();

  const products = [...shop.querySelectorAll('[data-bd-products] .bd-product')];
  shop.querySelectorAll('[data-bd-filter]').forEach((control) => {
    control.addEventListener('click', () => {
      const filter = control.dataset.bdFilter;
      shop.querySelectorAll('[data-bd-filter]').forEach((item) => item.classList.toggle('is-active', item === control));
      products.forEach((product) => {
        product.hidden = filter !== 'all' && !product.dataset.search.includes(filter);
      });
    });
  });
  shop.querySelector('[data-bd-sort]')?.addEventListener('change', (event) => {
    const grid = shop.querySelector('[data-bd-products]');
    const value = event.target.value;
    const sorted = [...products].sort((a, b) => {
      if (value === 'name') return a.dataset.title.localeCompare(b.dataset.title);
      if (value === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
      if (value === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
      return 0;
    });
    sorted.forEach((product) => grid.append(product));
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form[data-old-racket-service="true"]');
  if (!form) return;
  const logo = form.querySelector('[data-service-logo]');
  const logoChoice = form.querySelector('[data-service-logo-choice]');
  const logoBrand = form.querySelector('[data-service-logo-brand]');
  const total = form.querySelector('[data-service-total]');
  const methodInputs = [...form.querySelectorAll('[data-service-method]')];
  const shippingGuide = form.querySelector('[data-service-shipping-guide]');
  const mailConfirm = form.querySelector('[data-service-mail-confirm]');
  const updateServiceMethod = () => {
    const method = methodInputs.find((input) => input.checked)?.value || '';
    const isMailIn = method === 'Mail in and ship back';
    shippingGuide.hidden = !isMailIn;
    mailConfirm.required = isMailIn;
    if (!isMailIn) mailConfirm.checked = false;
  };
  methodInputs.forEach((input) => input.addEventListener('change', updateServiceMethod));
  updateServiceMethod();
  logo?.addEventListener('change', () => {
    const baseCents = Number(total.dataset.baseCents || 3000);
    const logoCents = Number(total.dataset.logoCents || 200);
    total.textContent = '$' + ((baseCents + (logo.checked ? logoCents : 0)) / 100).toFixed(2);
    logoChoice.hidden = !logo.checked;
    logoBrand.required = logo.checked;
    if (!logo.checked) logoBrand.value = '';
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = form.querySelector('button[type="submit"]');
    const customerName = form.querySelector('[data-service-customer-name]').value.trim();
    const phone = form.querySelector('[data-service-phone]').value.trim();
    const racket = form.querySelector('[data-service-racket]').value.trim();
    const string = form.querySelector('[data-service-string]').value;
    const tension = form.querySelector('[data-service-tension]').value;
    const serviceMethod = methodInputs.find((input) => input.checked)?.value || '';
    if (!form.reportValidity()) {
      return;
    }
    const data = new FormData(form);
    const quantity = Number(data.get('quantity') || 1);
    const setup = {
      'Customer name': customerName,
      'Phone number': phone,
      'Racket name/model': racket,
      'Service method': serviceMethod,
      'String': string,
      'Tension': tension,
      'Logo stencil': logo.checked ? `${logoBrand.value} (+$2)` : 'No',
      'Shipping note': serviceMethod === 'Mail in and ship back' ? 'Customer ships racket to Baraka; return shipping through checkout' : 'Customer will drop off and pick up in Warren'
    };
    const items = [{ id: Number(data.get('id')), quantity, properties: setup }];
    if (logo.checked) {
      items.push({ id: Number(form.dataset.logoVariant), quantity, properties: { 'For service': 'Old racket stringing', 'Logo': logoBrand.value, 'Customer name': customerName, 'Phone number': phone, 'Racket name/model': racket, 'Service method': serviceMethod, 'String': string, 'Tension': tension } });
    }
    submit.disabled = true;
    submit.textContent = 'Adding setup…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch {
      submit.disabled = false;
      submit.textContent = 'Add stringing setup to cart';
      window.alert('This setup could not be added. Please try again or call Baraka at (586) 356-6244.');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form[data-racket-form="true"]');
  if (!form) return;
  const logo = form.querySelector('[data-racket-logo]');
  const logoChoice = form.querySelector('[data-racket-logo-choice]');
  const logoBrand = form.querySelector('[data-racket-logo-brand]');
  const total = form.querySelector('[data-racket-total]');
  const submit = form.querySelector('button[type="submit"]');
  const serviceWantedInputs = [...form.querySelectorAll('[data-racket-service-wanted]')];
  const serviceFields = form.querySelector('[data-racket-service-fields]');
  const stringSelect = form.querySelector('[data-racket-string]');
  const tensionSelect = form.querySelector('[data-racket-tension]');

  const wantsService = () => serviceWantedInputs.find((input) => input.checked)?.value === 'yes';

  const updateServiceWanted = () => {
    const wanted = wantsService();
    if (serviceFields) serviceFields.hidden = !wanted;
    if (stringSelect) stringSelect.required = wanted;
    if (tensionSelect) tensionSelect.required = wanted;
    if (submit) submit.textContent = wanted ? 'Add racket + setup to cart' : 'Add to cart';
    if (!wanted) {
      if (stringSelect) stringSelect.value = '';
      if (tensionSelect) tensionSelect.value = '';
      if (logo) logo.checked = false;
      if (logoChoice) logoChoice.hidden = true;
      if (logoBrand) { logoBrand.required = false; logoBrand.value = ''; }
      if (total) total.textContent = '$25.00';
    }
  };
  serviceWantedInputs.forEach((input) => input.addEventListener('change', updateServiceWanted));
  updateServiceWanted();

  logo?.addEventListener('change', () => {
    total.textContent = logo.checked ? '$27.00' : '$25.00';
    logoChoice.hidden = !logo.checked;
    logoBrand.required = logo.checked;
    if (!logo.checked) logoBrand.value = '';
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const wanted = wantsService();
    const string = stringSelect ? stringSelect.value : '';
    const tension = tensionSelect ? tensionSelect.value : '';
    if (wanted && (!string || !tension)) {
      stringSelect?.reportValidity();
      tensionSelect?.reportValidity();
      return;
    }
    const data = new FormData(form);
    const quantity = Number(data.get('quantity') || 1);
    const productTitle = form.dataset.productTitle;
    const items = [];
    if (wanted) {
      const setup = {
        'Stringing service': '$25 new-racket service',
        'String': string,
        'Tension': tension,
        'Logo stencil': logo.checked ? `${logoBrand.value} (+$2)` : 'No'
      };
      items.push({ id: Number(data.get('id')), quantity, properties: setup });
      items.push({ id: Number(form.dataset.serviceVariant), quantity, properties: { 'For racket': productTitle, 'String': string, 'Tension': tension } });
      if (logo.checked) {
        items.push({ id: Number(form.dataset.logoVariant), quantity, properties: { 'For racket': productTitle, 'Logo': logoBrand.value } });
      }
    } else {
      items.push({ id: Number(data.get('id')), quantity });
    }
    submit.disabled = true;
    submit.textContent = wanted ? 'Adding setup…' : 'Adding to cart…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch {
      submit.disabled = false;
      submit.textContent = wanted ? 'Add racket + setup to cart' : 'Add to cart';
      window.alert('This could not be added. Please try again or call Baraka at (586) 356-6244.');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('[data-home-slider]');
  if (!slider) return;
  const slides = [...slider.querySelectorAll('.home-media-slide')];
  const tabs = [...slider.querySelectorAll('[data-home-dot]')];
  let active = 0;
  let timer;
  const show = (index) => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === active);
      slide.querySelector('video')?.[i === active ? 'play' : 'pause']();
    });
    tabs.forEach((tab, i) => tab.classList.toggle('is-active', i === active));
  };
  const restart = () => {
    clearInterval(timer);
    timer = setInterval(() => show(active + 1), 7000);
  };
  slider.querySelector('[data-home-prev]')?.addEventListener('click', () => { show(active - 1); restart(); });
  slider.querySelector('[data-home-next]')?.addEventListener('click', () => { show(active + 1); restart(); });
  tabs.forEach((tab, i) => tab.addEventListener('click', () => { show(i); restart(); }));
  restart();
});
